import UsuarioInfoStore from './UsuarioInfoStore';
import UsuarioListStore from './UsuarioListStore';
import UsuarioRolesStore from './UsuarioRolesStore';
import UsuarioUpsertStore from './UsuarioUpsertStore';
import UsuarioSucursalStore from './UsuarioSucursalStore';
import UsuarioPasswordStore from './UsuarioPasswordStore';
import UsuarioPermissionStore from './UsuarioPermissionStore';

const UsuarioStore = {
  list: UsuarioListStore,
  info: UsuarioInfoStore,
  roles: UsuarioRolesStore,
  upsert: UsuarioUpsertStore,
  password: UsuarioPasswordStore,
  sucursales: UsuarioSucursalStore,
  permissions: UsuarioPermissionStore,
};

export default UsuarioStore;
